import { getDistance } from "ol/sphere";
import React from "react";
import FlashMessage, { showMessage } from "react-native-flash-message";
import { RFeature, RLayerVector, RStyle } from "rlayers";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";

function PoisMapa(RouterData, features, location, callbackClick) {
  const { recursos, itinerari, currentItinerari, idioma } =
    RouterData.route.params;

  const poiIconSize = 0.1;

  const puntDisponible = getRecursURL(
    recursos,
    "itinerari_punt_disponible",
    idioma
  );
  const puntActual = getRecursURL(recursos, "itinerari_punt_actual", idioma);
  const puntPrimer = getRecursURL(recursos, "itinerari_punt_inici", idioma);
  const puntPrimerRealitzat = getRecursURL(
    recursos,
    "itinerari_punt_inici_realitzat",
    idioma
  );
  const puntRealitzat = getRecursURL(
    recursos,
    "itinerari_punt_realitzat",
    idioma
  );
  const puntFinal = getRecursURL(recursos, "itinerari_punt_final", idioma);
  const puntFinalRealitzat = getRecursURL(
    recursos,
    "itinerari_punt_final_realitzat",
    idioma
  );

  FlashMessage.setColorTheme({
    success: "#25c879",
    info: "#715f4d",
    warning: "#715f4d",
    danger: "#d990fb",
  });

  //todo
  const _renderFeatures = (feature, icon, poi) => {
    // if(currentItinerari.currentOrder == poi.order)
    // {
    //     getAngle([parseFloat(poi.location[0]),parseFloat(poi.location[1])])
    // }
    return (
      <RLayerVector key={poi.id}>
        <RStyle.RStyle>
          <RStyle.RIcon src={icon} scale={poiIconSize} />
        </RStyle.RStyle>
        <RFeature
          key={feature.get("uid")}
          feature={feature}
          onClick={(e) => {
            poi.done ? console.log("Joc ja completat") : poiEvents(poi, e);
          }}
        />
      </RLayerVector>
    );
  };
  // get angle between gyroscope and poi
  // const getAngle = (poi) => {
  //     const angle = Math.atan2(poi[1] - location[1], poi[0] - location[0]) * 180 / Math.PI;
  // }

  const poiEvents = (poi, e) => {
    const _poi = itinerari.pois.find((e) => e.id === poi.id);

    if (!_poi?.distancia_activacio) {
      return showMessage({
        message: "No té distància d'activació",
        description: "No té distància d'activació",
        type: "warning",
        icon: { icon: "auto", position: "left" },
      });
    }

    if (currentItinerari.currentOrder != poi.order) {
      return showMessage({
        message: getRecursText(recursos, "distancia_titol", idioma),
        description: getRecursText(recursos, "distancia_descripcio", idioma),
        type: "warning",
        icon: { icon: "auto", position: "left" },
      });
    }

    const distance = getDistance(
      [parseFloat(poi.location[0]), parseFloat(poi.location[1])],
      location
    );

    const distanciaActivacio = _poi.metresActivacio || 20;

    if (itinerari.jugar_des_de_casa || distance <= distanciaActivacio) {
      currentItinerari.comencat = true;

      e.map.getView().fit(e.target.getGeometry().getExtent(), {
        duration: 1000,
        maxZoom: 17,
      });

      return callbackClick(poi);
    }

    return showMessage({
      message: getRecursText(recursos, "distancia_titol", idioma),
      description: getRecursText(recursos, "distancia_descripcio", idioma),
      type: "warning",
      icon: { icon: "auto", position: "left" },
    });
  };

  const getPoiIcon = (element) => {
    if (element.isFirst) {
      return element.done ? puntPrimerRealitzat : puntPrimer;
    }
    if (element.isLast) {
      return element.done ? puntFinalRealitzat : puntFinal;
    }
    if (element.done) {
      return puntRealitzat;
    }
    return currentItinerari.currentOrder == element.order
      ? puntActual
      : puntDisponible;
  };

  const pois = currentItinerari.pois
    .filter(
      (element) =>
        element.isFirst || element.done // nomes es mostren els punts que son el primer o els punts fets
    )
    .map((element) => {
      const feature = features.find((f) => f.get("uid") === element.id);
      return feature ? _renderFeatures(feature, getPoiIcon(element), element) : null;
    })
    .filter((poi) => poi !== null);

  return pois;
}

export default PoisMapa;

//    e.map.getView().fit(e.target.getGeometry().getExtent(), {duration: 1000, maxZoom: 17});
